module.exports = __webpack_public_path__ + "static/media/Design_mordenboard.a326c34f.png";